export default function portalUsersHierarchy(params) {
    console.log('portalUsersHierarchy', params);

    this.popup('portalUsersHierarchy', {
        params: params,
        header: this.translate('LBL_PORTAL_HIERARCHY_TITLE', 'Accounts'),
    });
}
